<template>
<div class="wrapper">
    <div v-if="ifValid">
        <div class="message">
        <img :src="imgUrl.success" />
        <p ><span>成功查到了该报告的信息！</span></p>
        <p ><span>请您核对下方信息是否与纸面内容一致。</span></p>
        </div>
        
        <!--<p class="table-title">报告信息</p>-->
        <table class="info">
            <tr>
                <td>报告编号：</td><td>{{reportInfo.report_display_no}}</td>
            </tr>
            <tr>
                <td>客户名称：</td><td>{{reportInfo.customer}}</td>
            </tr>
            <tr>
                <td>委托日期：</td><td>{{reportInfo.create_time}}</td>
            </tr>
            <!-- <tr>
                <td>发布日期：</td><td>{{reportInfo.approve_time}}</td>
            </tr> -->
            <tr>
                <td>样品名称：</td><td>{{reportInfo.sample_name}}</td>
            </tr>
        </table>
    </div>
    <div v-else-if="ifValid!==undefined">
        <div class="message">
        <img :src="imgUrl.fail" />
        <p ><span>未查到相关报告的信息！</span></p>
        <p ><span>请您联系本公司再次核实。</span></p>
        </div>
    </div>
    <div v-else>

    </div>
    
</div>
    
</template>
<script>
export default {
    name:'reviewSuccess',
    props: {
    report_enid: {
      type: String,
      default:"",
  },},
    data(){
        return {
            reportInfo:{},
            ifValid:undefined,
            imgUrl:{
                success:process.env.BASE_URL + "img/success.jpg",
                fail:process.env.BASE_URL + "img/fail.jpg"
            } 
        }
    },
    created() {
        if(this.report_enid){
            this.getInfo(this.report_enid);
        }
  },
    mounted(){
    },
    methods: {
        getInfo(rid){
            this.$axios
        .post(this.$url + '/report_distinguish', {
          report_enid:rid
        })
        .then(response => {
            if(response.data.stat==='ok'){
                this.reportInfo = response.data.res_record;
                this.ifValid = true;
            }else{
                this.ifValid = false;
            }
        }).catch(error=>{
            this.$toast.fail("无法连接到服务器！"+error);
        }

        );
        }

    },
    
}
</script>
<style scoped>
div.wrapper{
    width:90%;
    margin:0 auto;
}
table.info{
    border-collapse: collapse;
    width:100%;
}

table.info td{
    height:2rem;
    border-top:1px solid #ddd;
    border-bottom: 1px solid #ddd;
}

table.info td:first-child{
    font-size:0.6rem;
    color:#555;
    width:4rem;
    text-align: right;
}

table.info td:last-child{
    font-size:0.6rem;
    color:#111;
    text-align: center;
}

.table-title{
    text-align: center;
    line-height: 3rem;
    font-size:0.8rem;
    color:#444;
}

.message{
    font-size:0.7rem;
    text-align: center;
    padding:2rem 0; 
}

.message img{
    width:5rem;
}


</style>